import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../constant/config.json";
import { Link } from "react-router-dom";

export const Footer = () => {
  const [formData, setFormData] = useState({ name: "", phoneNumber: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [captchaNumbers, setCaptchaNumbers] = useState({ num1: 0, num2: 0 });
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaNumbers({ num1, num2 });
    setCaptchaAnswer("");
    setCaptchaError("");
  };

  const validateForm = (formData) => {
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      errors.name = "Name should contain only letters";
    }
    if (!formData.phoneNumber.trim()) {
      errors.phoneNumber = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phoneNumber)) {
      errors.phoneNumber = "Enter valid 10-digit number";
    }
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData);
    const correctAnswer = captchaNumbers.num1 + captchaNumbers.num2;
    if (parseInt(captchaAnswer) !== correctAnswer) {
      setCaptchaError("Incorrect captcha");
      generateCaptcha();
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        await axios.post(`${config.API_URL}api/newsletter/contactus`, formData);
        setFormData({ name: "", phoneNumber: "" });
        setErrors({});
        setFormMessage("Form submitted successfully!");
      } catch (error) {
        console.error("Error submitting data:", error);
        setFormMessage("Failed to submit form.");
      } finally {
        setLoading(false);
        generateCaptcha();
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleNameInput = (e) => {
    const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
    setFormData({ ...formData, name: value });
    setErrors({
      ...errors,
      name: value.trim() === "" ? "Name is required" : "",
    });
  };

  const handlePhoneInput = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setFormData({ ...formData, phoneNumber: value });
    setErrors({
      ...errors,
      phoneNumber:
        value.length === 0
          ? "Phone number is required"
          : value.length !== 10
            ? "Enter valid 10-digit number"
            : "",
    });
  };

  return (
    <>
      <footer className="footer prt-bg bg-base-dark widget-footer clearfix">
        <div className="prt-row-wrapper-bg-layer"></div>
        <div className="first-footer">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget-box">
                  <img
                    style={{ padding: "0px 20px" }}
                    src="images/logos/digital_signage_logo.png"
                    alt="Logo"
                  />
                  <br />
                  <br />
                  <p className="prt-numbertext-p">
                    From Vision to Reality, We've Got You Covered. Experience
                    the Difference with Our Digital Signage Solutions.
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget-box">
                  <h3
                    className="widget-title-h3 h3-footer"
                    style={{ color: "#f7db05" }}
                    >
                    Get In Touch
                  </h3>
                  <div className="widget_nav_menu">
                    <div className="textwidget-widget-text">
                      <div className="prt-numbertext">
                        <h3>INDIA</h3>
                        <p className="prt-numbertext-p">
                          <Link to="tel:9167860213" className="phone-link" target="_blank">
                            <span className="city-label">Mumbai</span>
                            <span className="phone-number">+91 91678 60213</span>
                          </Link>
                        </p>

                        <p className="prt-numbertext-p" style={{ marginBottom: "20px" }}>
                          <Link to="tel:9953750766" className="phone-link" target="_blank">
                            <span className="city-label">Delhi</span>
                            <span className="phone-number">+91 99537 50766</span>
                          </Link>
                        </p>
                        <p className="prt-numbertext-p">
                          DIGITAL SIGNAGE COMPANY
                          <br /> [OTTOEDGE GROUP]
                        </p>
                        <p className="prt-numbertext-p">
                          U5/5, Plot No - 2, Green Industrial Park, Kaman,
                          Chinchoti Anjur Phata Rd, Poman, Navghar, Maharashtra
                          401208
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-3 col-md-6 col-sm-12 footer-add"
                style={{ marginTop: "56px" }}
                >
                <div className="footer-widget-box">
                  <div className="widget_nav_menu">
                    <div className="textwidget-widget-text">
                      <div className="prt-numbertext">
                        <h3>DUBAI</h3>
                        <p className="prt-numbertext-p">
                          <Link
                            to="tel:9167860213"
                            className="prt-numbertext-p"
                            target="_blank"
                            >
                            +971 50 271 7265
                          </Link>
                        </p>
                        <p className="prt-numbertext-p">
                          DIGITAL SIGNAGE COMPANY
                          <br /> [OTTOEDGE GROUP]
                        </p>
                        <p className="prt-numbertext-p">
                          Boulevard Plaza Tower 2 Floor 22 Sheikh Mohammed bin
                          Rashid Boulevard Dubai - United Arab Emirates
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget-box">
                  <h3 className="widget-title-h3" style={{ color: "#f7db05" }}>
                    Contact Us
                  </h3>
                  <form onSubmit={handleSubmit}>
                    {formMessage && (
                      <p className="form-message">{formMessage}</p>
                    )}
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleNameInput}
                        className={`form-control ${errors.name && "is-invalid"}`}
                        placeholder="Enter your name"
                      />
                      {errors.name && (
                        <span className="error-text">{errors.name}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input
                        type="text"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handlePhoneInput}
                        maxLength={10}
                        className={`form-control ${errors.phoneNumber && "is-invalid"}`}
                        placeholder="Enter your phone number"
                        inputMode="numeric"
                      />
                      {errors.phoneNumber && (
                        <span className="error-text">{errors.phoneNumber}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Resolve captcha:</label>
                      <div className="d-flex align-items-center">
                        <span
                          style={{
                            marginRight: "8px",
                            backgroundColor: "#ffffff",
                            color: "#000",
                            padding: "1px 5px",
                            fontWeight: "500",
                          }}>
                          {captchaNumbers.num1} + {captchaNumbers.num2} =
                        </span>
                        <input
                          type="text"
                          value={captchaAnswer}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setCaptchaAnswer(value);
                          }}
                          className="form-control"
                          style={{
                            width: "60px",
                            padding: "2px",
                            textAlign: "center",
                          }}
                        />
                      </div>
                      {captchaError && (
                        <span className="error-text">{captchaError}</span>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-fill prt-btn-color-white mt-25"
                      >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-footer-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright">
                  <p>
                    Copyright © {new Date().getFullYear()}{" "}
                    <Link to="https://digitalsignagecompany.in/">
                      Digital signage
                    </Link>{" "}
                    is Owned by{" "}
                    <Link to="https://ottoedge.com/" target="_blank">
                      Ottoedge Services LLP
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a id="totop" to="#top" style={{ cursor: "pointer" }}>
        <i className="icon-angle-up"></i>
      </a>
    </>
  );
};
